















































































































import { Component, Vue } from 'vue-property-decorator'

@Component({
	name: 'ButtonOne'
})
export default class ButtonOne extends Vue {
}
